module.exports = __webpack_public_path__ + "images/snappcar_smallc6ff8769d08851da2d49d87f81275a61.png";